module.exports = __webpack_public_path__ + "static/media/added.4438f39e.svg";